import React, { useContext, useEffect, useMemo, useState } from 'react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
// import { useAuth } from 'oidc-react'
import withConfig from '../../wrappers/withConfig'
import { UserContext } from '../../wrappers/UserContext'

dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(duration)

export default withConfig(({config}) => {
    // const { userData: user } = useAuth()
    const { client, user } = useContext(UserContext)
    const [ expiresAt, setExpiresAt ] = useState(null)
    const [timeRemaining, setTimeRemaining] = useState(config.INACTIVITY_TIME)
    const [displayTime, setDisplayTime] = useState(config.INACTIVITY_TIME)
    const [intervalEvent, setIntervalEvent] = useState(null)
    if (!user) {
        localStorage.removeItem('expiresAt')
        return null
    }

    useEffect(() => {
        const now = dayjs().valueOf()
        const msToExpiry = config.INACTIVITY_TIME * 1000        
        const expires = now + msToExpiry
        setExpiresAt(expires)
        localStorage.setItem('expiresAt', expires)
        
        window.addEventListener('click', e => {
            localStorage.removeItem('expiresAt')
            localStorage.setItem('expiresAt', dayjs().valueOf() + config.INACTIVITY_TIME * 1000)
            // update setExpiresAt with sessionStorage tracked value
            setExpiresAt(dayjs().valueOf() + config.INACTIVITY_TIME * 1000)
        }, {capture: true})
    }, [])

    useEffect(() => {
        clearInterval(intervalEvent)
        // set an interval to update the countdown
        const i = setInterval(() => {
            const localStorageExpiresAt = localStorage.getItem('expiresAt')
            
            const now = dayjs().valueOf()
            setTimeRemaining(localStorageExpiresAt - now)
            const deltaT = dayjs.duration(localStorageExpiresAt - now, 'milliseconds')
            let hours = deltaT.hours()
            let mins = deltaT.minutes()
            let seconds = deltaT.seconds()
            if (timeRemaining < 0) {
                client.signoutRedirect()
                return
            }
            setDisplayTime(`${hours.toString().padStart(2, "0")}h ${mins.toString().padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`)
        }, 1000)
        setIntervalEvent(i)
    }, [timeRemaining, expiresAt])

    return (
        <div className="navbar-item">
            Session Expires in {displayTime}
        </div>
    )
})